<footer class="footer">
  <div class="footer__container">
    <!-- Top Section -->
    <div class="footer__top">
      <div class="footer__top-half">
        <!-- Branding -->
        <div class="footer__branding">
          <img
          src="assets/img/logo-stc-white.png"
          alt="STC Logo"
          class="footer__logo"
          loading="lazy"
        />
        <a
          href="https://www.stc.com.sa/content/stcgroupwebsite/sa/en/who-we-are.html?_gl=1*1y7r62m*_gcl_au*OTIyODUyNzI0LjE2ODU5MTE1Mjk."
          class="footer__stc-link"
        >
          {{ "stc-group-website" | translate }}
        </a>
      </div>

      <!-- Contacts -->
      <div class="footer__contacts">
        <div class="footer__contact">
          <div class="footer__contact-header">
            <img src="assets/img/email.png" alt="Email" class="footer__icon" loading="lazy" />
            <span>{{ "saudi-arabia" | translate }}</span>
          </div>
          <a href="mailto:info@channels.com.sa" class="footer__email-link">
            info&#64;channels.com.sa
          </a>
        </div>
        <div class="footer__contact">
          <div class="footer__contact-header">
            <img src="assets/img/email.png" alt="Email" class="footer__icon" loading="lazy" />
            <span>{{ "oman" | translate }}</span>
          </div>
          <a href="mailto:info@channels.com.om" class="footer__email-link">
            info&#64;channels.com.om
          </a>
        </div>
        <div class="footer__contact">
          <div class="footer__contact-header">
            <img src="assets/img/email.png" alt="Email" class="footer__icon" loading="lazy" />
            <span>{{ "bahrain" | translate }}</span>
          </div>
          <a href="mailto:info@channels.com.bh" class="footer__email-link">
            info&#64;channels.com.bh
          </a>
        </div>
        <div class="footer__contact">
          <div class="footer__contact-header">
            <img src="assets/img/email.png" alt="Email" class="footer__icon" loading="lazy" />
            <span>{{ "kuwait" | translate }}</span>
          </div>
          <a href="mailto:info@channels.com.kw" class="footer__email-link">
            info&#64;channels.com.kw
          </a>
        </div>
      </div>
    </div>

      <!-- Social -->
      <div class="footer__social">
        <span>{{ "follow-us" | translate }}</span>
        <div class="footer__social-icons">
          <a href="https://www.facebook.com/Channels.bystc/">
            <img src="assets/img/facebook.png" alt="Facebook" loading="lazy" />
          </a>
          <a href="https://twitter.com/channels_bystc">
            <img src="assets/img/x-icon.jpg" alt="Twitter" loading="lazy" />
          </a>
          <a href="https://www.youtube.com/c/channelsbystc">
            <img src="assets/img/youtube.png" alt="YouTube" loading="lazy" />
          </a>
          <a href="https://sa.linkedin.com/company/channelsbystc">
            <img src="assets/img/linked-in.png" alt="LinkedIn" loading="lazy" />
          </a>
          <a href="https://www.instagram.com/channels_bystc">
            <img src="assets/img/instagram.png" alt="Instagram" loading="lazy" />
          </a>
        </div>
      </div>
    </div>

    <!-- Middle Section -->
    <div class="footer__middle">
      <a href="#" class="footer__link">
        {{ "corporate-sales" | translate }}
      </a>
      <span class="footer__separator"></span>
      <a href="https://career.channels.com.sa" class="footer__link">
        {{ "career" | translate }}
      </a>
    </div>

    <!-- Divider -->
    <hr class="footer__hr" />

    <!-- Bottom Section -->
    <div class="footer__bottom">
      <div class="footer__bottom-links">
        <a [routerLink]="['/privacy-and-policy']" class="footer__bottom-link">
          {{ "privacy-and-policy" | translate }}
        </a>
        <a
          href="https://pubstorage01.blob.core.windows.net/externalwebsite01prod/users-rights-postal.pdf"
          class="footer__bottom-link"
        >
          {{ "citc-postal-regulation" | translate }}
        </a>
        <a
          href="https://delivery.channels.com.sa/shipmentsTracking"
          class="footer__bottom-link"
        >
          {{ "shipment-tracking" | translate }}
        </a>
      </div>
      <div class="footer__bottom-text">
        <span class="footer__bottom-text">
          {{ "postal-service-contact-number" | translate }}
        </span>
        <span
          >&copy; {{ dateYear }} {{ "all-rights-reserved" | translate }}
        </span>
      </div>
    </div>
  </div>
</footer>
